import { createCookie, hasCookie } from '@rover/utilities/cookie';
import { addEventParamsToUrl } from '@rover/utilities/url';
import dataLayer from '@rover/globals/dataLayer';
import Mustache from '@rover/globals/Mustache';

import ModalView from '../../../components/rover_modal';
import { CALLOUTS } from './constants';

export default ModalView.extend({
  COOKIE_NAME: 'qm_recovery_modal',

  initialize(options) {
    ModalView.prototype.initialize.call(this, {
      classes: 'quick-match-recovery-modal',
      ...options,
    });
    this.listenTo(this.model, 'change', () => this.onSearchResultsChanged());
    this.$('.js-modal-close').on('click', () => this.onModalDismiss());
  },

  getContent() {
    const template = Mustache.template('search/quick_match_recovery_modal');

    // We'll assume that calloutData will always be defined if this is
    // being called (due to the check in onSearchResultsChanged)
    const calloutData = this.quickMatchCalloutData();

    // showFiveFreeWalksPromo is specific to the Five Free Walks promo.
    // Otherwise, we'll show a generic promo
    const showFiveFreeWalksPromo = !!(
      calloutData.configuration.default_promo &&
      calloutData.configuration.default_promo.description_type === 'five_free_walks'
    );
    const landingPageUrl = addEventParamsToUrl(calloutData.configuration.landing_page_url, [
      { event: 'quick-match-search-pg2-get-a-quick-match' },
    ]);
    return template.render({ showFiveFreeWalksPromo, landingPageUrl });
  },

  shownRecently() {
    return hasCookie(this.COOKIE_NAME);
  },

  markAsShown() {
    createCookie(this.COOKIE_NAME, '1', 1);
  },

  quickMatchCalloutData() {
    const hybridCallout = this.model
      .get('callouts')
      .find(c => c.slug === CALLOUTS.HYBRID_DOG_WALKING);
    return hybridCallout && hybridCallout.data;
  },

  onSearchResultsChanged() {
    const isPageOne = this.model.get('page_number') === 1;
    const qmCalloutData = this.quickMatchCalloutData();
    return !this.shownRecently() && !isPageOne && qmCalloutData ? this.open() : null;
  },

  open() {
    this.setContent(this.getContent());
    ModalView.prototype.open.call(this);
    dataLayer.push({
      event: 'quick-match-search-pg2-display',
      nonInteractive: true,
    });
    this.markAsShown();
  },

  onModalDismiss() {
    dataLayer.push({ event: 'quick-match-search-pg2-dismiss' });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/quick_match_recovery_modal.js